import { useState } from 'react';
import {
  addToArray,
  filterOutValue,
  mergeWithoutDuplicates,
} from '@witmetrics/utils/arrays';

export function useInvalidFields(initialValue?: string[]) {
  const [fields, setFields] = useState<string[]>(initialValue || []);

  const clear = () => setFields([]);

  const reset = () => setFields(initialValue || []);

  // true = valid, false = invalid
  const isValidField = (field: string) => !fields.includes(field);

  const addField = (field: string) => {
    return setFields((f) => addToArray(f, field));
  };

  const addFields = (newFields: string[]) => {
    return setFields((f) => mergeWithoutDuplicates(f, newFields));
  };

  const removeField = (field: string) => {
    return setFields((f) => filterOutValue(f, field));
  };

  return {
    invalidFields: fields,
    setInvalidFields: setFields,
    clear,
    reset,
    isValidField,
    addField,
    addFields,
    removeField,
  } as const;
}
